import React, { useState } from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";
import Barchart from "./Charts";
import { useEffect } from "react";
import { GetDashletAPI } from "../../services";
import { Link } from "react-router-dom";
import { BarChartSkeleton, DashletSkeleton } from "../layouts/Skeleton";
import Calendar from "./Calendar";

const Dashlet = ({structure, data, type, onCountLoad}) =>
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [loading, SetLoading] = useState(true);
	const [value, SetValue] = useState(false);
	const [title, SetTitle] = useState((data.name && language.DASHBOARD[data.name.toUpperCase()]) || '');
	const [HTML, SetHTML] = useState('');
	const [dashletData, SetDashletData] = useState({type:'', icon:'fa fa-star', color:'rgb(var(--color-primary),1)', link:''});	
	const size = data.name === 'Calendar' ? 'col-span-4' : (data.name === 'WorkOrdersStatus' ? 'col-span-2' : '');
	
	useEffect(() => {
		GetData();
	// eslint-disable-next-line
	}, []);

	useEffect(() => {

		if (value !== false) 
		{	
			if (structure === 'basic') 
			{
				if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) 
				{
			    	SetHTML(<div className="text-2xl font-bold mb-4">{value}</div>);
					return;
			    }

				let items;
				if (Array.isArray(value)) 
				{
					items = value;
				}
				else if (typeof value === 'object' && value !== null) 
				{
					items = Object.values(value);
				}
				else
				{
					items = [{ title: data.title, count: value }];
				}

				const display = items.map((v, i) => {
					const inner = (
						<>
							<span className="text-sm">{v.title ?? v.label}</span>
							<span className="text-xs text-gray-400">{v.count ?? v.date ?? ''}</span>
						</>
					);

					if (v.linkTo === 'list' && v.filterField)
					{
						const initialFilter = [{ field: v.filterField, operator: v.filterOperator, value: v.filter }];
						return (
							<Link key={i} to={`/list/${data.module}`} state={{ initialFilter }}
								className="flex justify-between items-center py-2">
								{inner}
							</Link>
						);
					}

					if (v.id) 
					{
						return (
							<Link key={i} to={`${v.linkTo}`}
								className="flex justify-between items-center py-2">
								{inner}
							</Link>
						);
					}

					return (
						<div key={i} className="flex justify-between items-center py-2">
							{inner}
						</div>
					);
				});

				SetHTML(<div className="w-full divide-y divide-gray-100">{display}</div>);
			}
			else
			{
				let content;
				const isStackedType = dashletData.type === 'stackedbarchart';
				const stackedSeries = Array.isArray(value?.series) ? value.series : Object.values(value?.series || {});
				const stackedLabels = Array.isArray(value?.labels) ? value.labels : Object.values(value?.labels || {});
				const hasStackedData = isStackedType && stackedSeries.length > 0;
				if((isStackedType && hasStackedData) || (!isStackedType && (Object.values(value).length || dashletData.type === 'calendar')))
				{
					switch (dashletData.type)
					{
						case 'barchart': 
							content = <Barchart labels={Object.keys(value)} data={Object.values(value)} type={dashletData.type} />; break;
						case 'stackedbarchart':
							content = <Barchart stackedData={{labels: stackedLabels, series: stackedSeries}} type={dashletData.type} />; break;
						case 'piechart': 
							content = <Barchart labels={Object.keys(value)} data={Object.values(value)} type={dashletData.type} />; break;
						case 'piechart_group':
							const items = value.slice(0, 4);
							if (onCountLoad) onCountLoad(items.length);
							content = (
								<div className={`grid grid-cols-${items.length} gap-4 w-full`}>
									{items.map((item, index) => (
										<div key={index} className="flex flex-col items-center">
											<h6 className="text-sm mb-2 text-center">{item.name}</h6>
											<Barchart labels={Object.keys(item.data)} data={Object.values(item.data)} type="piechart" />
										</div>
									))}
								</div>
							);
							break;
						case 'calendar': 
							content = <Calendar data={value} />; break;
						default: content = ''; break;
					}
					SetHTML(content);
				}
				else
				{
					SetHTML(<div className="block flex items-center justify-center">{WithoutData()}</div>);
					SetDashletData({...dashletData, link:''});
				}
			}
		}
	// eslint-disable-next-line
	}, [value, dashletData.type]);

	const GetData = async () => {
		try {
			const APIData = {
				module: data.module,
				name: data.name,
			};
			const APIResponse = await GetDashletAPI(APIData);
			if(APIResponse)
			{
				SetLoading(false);
				if(APIResponse.value || APIResponse.value === 0)
				{
					const link = APIResponse.type !== 'calendar' && APIResponse.show_list ? '/list/'+data.module : '';
					SetValue(APIResponse.value);
					SetDashletData({type:APIResponse.type, icon:APIResponse.icon, color:APIResponse.color, link:link});
					if(APIResponse.title && (APIResponse.title.length || Object.keys(APIResponse.title).length))
					{
						const dashletTitle = (typeof APIResponse.title === 'object') ? APIResponse.title[preferences.language] : APIResponse.title;
						SetTitle(dashletTitle || title);
					}
				}
			}
			else
			{
				SetHTML(WithoutData());
				SetLoading(false);
			}
		} catch (error) {}
	};

	const WithoutData = () => {
		return <div className='py-4 text-center'><i className='fa fa-exclamation-triangle fa-3x'></i><div className='my-3'>{language.NO_DATA}</div></div>;
	}

	return <div className={`wrapper ${dashletData.link?.length > 0 ? 'flex flex-col justify-between' : ''} ${size}`}>
		{loading ? (structure === 'basic' ? <DashletSkeleton/> : <BarChartSkeleton/>)
		: <>
			<div className='title !border-0 !mb-1'>
				<h6>{title}</h6>
				<i className={dashletData.icon} style={{background: dashletData.color}}></i>
			</div>
			<div className={`min-h-[2rem] mb-4 flex justify-center w-90 ${data.name === 'WorkOrdersStatus' ? 'max-h-80' : 'max-h-52'}`}>{HTML}</div>
			{dashletData.link.length ?
				<Link to={dashletData.link} className='bg-highlightBG p-2 rounded border border-primaryBorder flex justify-between items-center text-sm cursor-pointer pe-1 hover:bg-disabled'>
					{language.DASHBOARD.DETAILS}
					<i className="fa fa-arrow-circle-left text-primary mx-2"></i>
				</Link>
			: null}
		</>
		}
	</div>
}

export default Dashlet;